import React from "react";
import PropTypes from "prop-types";
import "./styles.scss";
import Row from "../Row";
import Column from "../Column";

const Header = ({ columns, hasInputFile, fields, preLabelClass }) => {
  return (
    <Row isHeader={true}>
      {fields.map((field, index) => (
        <Column
          classIn={`${preLabelClass}--${field.tag}`}
          childrenDesktop={columns[field.tag]}
          key={index}
        />
      ))}
      {hasInputFile && (
        <Column
          classIn={`${preLabelClass}--actions2`}
          childrenDesktop="Adic. Arch."
          key={0}
        />
      )}
    </Row>
    // <Row isHeader={true}>
    //   {columns.map((col) => (
    //     <Column classIn={col.class} childrenDesktop={col.name} key={col.id} />
    //   ))}
    //   {hasInputFile && (
    //     <Column classIn="actions2" childrenDesktop="Adic. Arch." key={0} />
    //   )}
    // </Row>
  );
};

Header.defaultProps = {
  columns: {},
  fields: [],
};

Header.propTypes = {
  columns: PropTypes.object,
  fields: PropTypes.array,
  hasInputFile: PropTypes.bool,
};

export default Header;
